// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"613":"db3731ab","621":"0dd153ba","743":"9cfb79ac","759":"05ca95a0"}[chunkId] + ".chunk.js";
};